import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLInputElement> {
  static values = { url: String }

  declare urlValue: string

  async toggle(): Promise<void> {
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
    const checkbox = this.element
    const previous = !checkbox.checked

    try {
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json"
        }
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
    } catch (err) {
      checkbox.checked = previous
      console.error("Failed to toggle active:", err)
    }
  }
}
